import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import { Box, Divider, Typography } from '@mui/material';
import { Holding } from '@daml.js/dtc-registry-holding/lib/Dtc/Registry/Holding/V3/Holding';
import TemplateContract from '../utils/TemplateContract';
import { values } from '../utils/common';
import CopyableText from './CopyableText';
import { DetailsRow } from './DetailsRow';
import PartyDisplay from './PartyDisplay';

interface HoldingDetailProps {
  row?: TemplateContract<Holding>;
}
export const HoldingDetail: React.FC<HoldingDetailProps> = ({ row }) => {
  if (!row) {
    return null;
  }
  const details = [
    {
      label: 'holder',
      value: row.payload.owner,
    },
    {
      label: 'registrar',
      value: row.payload.registrar,
    },
    {
      label: 'Compliance',
      value: row.payload.compliance,
    },
    {
      label: 'Participant',
      value: row.payload.participant,
    },
    {
      label: 'Operator',
      value: row.payload.operator,
    },
    {
      label: 'label',
      value: row.payload.label,
    },
    {
      label: 'Lock',
      value: row.payload.lock
        ? values(row.payload.lock.lockers).map((party) => (
            <PartyDisplay key={uuidv4()} party={party} />
          ))
        : null,
    },
    {
      label: 'lock context',
      value: row.payload.lock ? row.payload.lock.context : '',
    },
  ];

  return (
    <Box
      sx={{
        flex: 1,
        flexDirection: 'column',
        overflowY: 'auto',
        flexGrow: 1,
        display: 'flex',
        overflow: 'hidden',
        pt: 1,
      }}
    >
      <Typography variant="body2" fontWeight="bold">
        Details
      </Typography>
      <DetailsRow
        label="Instrument Id"
        value={<CopyableText value={row.payload.instrument.id} />}
      />
      <DetailsRow label="amount" value={row.payload.amount} isNumber />
      <Divider sx={{ mt: 1, mb: 1 }} />
      {details.map((detail) => (
        <DetailsRow key={detail.label} value={detail.value} label={detail.label} />
      ))}
    </Box>
  );
};
